/** 2. SOPHIE — café-chalkboard skin. Free + editable for everyone: preferred name and home zip
 * (labelled "your corner of town"). Saves on blur. */
import { useEffect, useState } from 'react';
import type { Profile } from '@pghbites/shared';

interface SophieProps {
  profile: Profile;
  onSetField: (field: 'preferred_name' | 'zip_code', value: string) => void;
}

export function SophieWindow({ profile, onSetField }: SophieProps) {
  const [name, setName] = useState(profile.preferred_name);
  const [zip, setZip] = useState(profile.zip_code);

  // Keep local inputs in sync if the server canonical values change underneath us.
  useEffect(() => { setName(profile.preferred_name); }, [profile.preferred_name]);
  useEffect(() => { setZip(profile.zip_code); }, [profile.zip_code]);

  return (
    <div className="sec">
      <div className="seclabel"><span className="dot">💬</span> Sophie sets you up</div>
      <div className="chalk">
        <div className="hd"><span className="face">🌟</span><span className="t">Sophie</span></div>
        <div className="row">
          <label htmlFor="sophie-name">what should we call you?</label>
          <input
            id="sophie-name" type="text" value={name} placeholder="your name"
            onChange={(e) => setName(e.target.value)}
            onBlur={() => name !== profile.preferred_name && onSetField('preferred_name', name)}
          />
        </div>
        <div className="row">
          <label htmlFor="sophie-zip">home zip (your corner of town)</label>
          <input
            id="sophie-zip" type="text" inputMode="numeric" maxLength={5} value={zip} placeholder="15106"
            onChange={(e) => setZip(e.target.value.replace(/[^0-9]/g, ''))}
            onBlur={() => zip !== profile.zip_code && onSetField('zip_code', zip)}
          />
        </div>
      </div>
      <div className="hint">tap a line to edit →</div>
    </div>
  );
}
